import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { usePerson } from '../../contexts/PersonContext'

interface RouteGuardProps {
  /** Kids may not see this screen (redirect home). */
  denyKid?: boolean
  /** Solo accounts may not see this screen (redirect home). */
  denySolo?: boolean
  children: ReactNode
}

/**
 * Role/account guard for shell routes. Kid role is blocked from
 * /approvals, /safety, /onboard; solo accounts from /approvals, /onboard.
 * A denied route falls back to home ('/'), mirroring the dc.html VALID sets.
 */
export function RouteGuard({ denyKid, denySolo, children }: RouteGuardProps) {
  const { role, isSolo } = usePerson()
  if (denyKid && role === 'kid') return <Navigate to="/" replace />
  if (denySolo && isSolo) return <Navigate to="/" replace />
  return <>{children}</>
}
